import { render, staticRenderFns } from "./person-history.vue?vue&type=template&id=99be2b18"
import script from "./person-history.vue?vue&type=script&lang=js"
export * from "./person-history.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports